import React, { FC, useState } from 'react'
import style from '@src/components/Accordion/Accordion.module.scss'
import { ReactComponent as Arrow } from '@src/assets/accord_arrow.svg'

type FaqData = Record<string, string>;

type InfoArr = {
    faqArr?: FaqData;
}
const FaqAccordion: FC<InfoArr> = ({ faqArr }) => {
  const [activeKey, setActiveKey] = useState(null)

  const handleClick = (key: any) => {
    if (key === activeKey) {
      setActiveKey(null)
    } else {
      setActiveKey(key)
    }
  }
  return (
    <div className={style.accordion}>
      {faqArr && Object.entries(faqArr).map(([key, value]) => (
        <div key={key + value} className={`${style.accordionWrapper} ${activeKey === key && style.activeWrapper}`}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
          <div
            className={`${style.accordionWrapper_title} ${activeKey === key && style.active}`}
            onClick={() => handleClick(key)}
          >
            {key}
            <Arrow />
          </div>
          {activeKey === key
              && (
              <div
                className={style.accordionWrapper_description}
                dangerouslySetInnerHTML={{ __html: value }}
              />
              )}
          {' '}

        </div>
      ))}
    </div>
  )
}

export default FaqAccordion
